import {
  MeetingRoomNormalization,
  MeetingRoomProcessedStatus,
  MeetingRoomStatus,
  ProcessedMeetingRoomEvent,
} from './meetingroom-normalization.types';
import {GlobalContainerTypes, MeetingRoomEvent, MeetingRoomRawStatus} from '@innowise-group/core';
import {injectable} from 'inversify';
import {isEmpty} from 'lodash';
import {MeetingRoomStatusUpdate} from '../../../../modules/floors/services/floors-event-emitter';

@injectable()
class MeetingRoomNormalizationService implements MeetingRoomNormalization {
  public static readonly type = GlobalContainerTypes.MeetingRoomNormalization;

  constructor() {
    this.normalizeMeetingRoomStatus = this.normalizeMeetingRoomStatus.bind(this);
    this.normalizeMeetingRoomEvents = this.normalizeMeetingRoomEvents.bind(this);
  }

  public normalizeMeetingRoomStatus(
    meetingRoomStatus: MeetingRoomRawStatus | MeetingRoomStatusUpdate,
  ): MeetingRoomProcessedStatus | MeetingRoomStatus {
    const commonProperties = {
      isBusy: meetingRoomStatus.is_busy,
      ...(meetingRoomStatus?.next_booking && {nextBooking: meetingRoomStatus?.next_booking}),
      ...(meetingRoomStatus?.time_when_will_be_free && {timeWhenWillBeFree: meetingRoomStatus?.time_when_will_be_free}),
    };

    if (Object.hasOwn(meetingRoomStatus, 'capacity')) {
      const statusWithCapacity = meetingRoomStatus as MeetingRoomRawStatus;
      return {
        ...commonProperties,
        capacity: statusWithCapacity.capacity,
      };
    }

    return commonProperties;
  }

  public normalizeMeetingRoomEvents(events: MeetingRoomEvent[]): ProcessedMeetingRoomEvent[] {
    if (isEmpty(events)) return [];

    return events
      .map((event) => ({
        id: event.id,
        start: new Date(event.start_date),
        end: new Date(event.end_date),
        isDraggable: false,
      }))
      .sort((currentEvent, nextEvent) => (currentEvent.start < nextEvent.start ? -1 : 1));
  }
}

export default MeetingRoomNormalizationService;
